

const BottomPadding= ({ pad }) => {

    return(
    <div style={{position:'relative', bottom:'0px',  height:'120px', width:'100%', backgroundColor:'#F2EBEB'}}></div>
    )
}

export default BottomPadding